import * as React from 'react';
declare const I18n;

type Props = {
  value: string,
  error: string,
  type: string,
  field: string,
  label: string,
  helperText?: string,
  className?: string,
  columnSize: number,
  style?: object,
  innerStyle?: object
  onChange(value: string): void,
}

const TextInput: React.FunctionComponent<Props> = ({
  value,
  error,
  type,
  field,
  label,
  helperText,
  className,
  columnSize,
  style,
  innerStyle,
  onChange,
}: Props): JSX.Element => (
  <div className={`col-md-${columnSize}`} style={style}>
    <div className="form-group" style={innerStyle}>
      {!helperText && (<label className={className} htmlFor={`${type}_${field}`}>{label}</label>)}
      {helperText && (
        <>
          <label className={className} style={{ marginBottom: "0rem", lineHeight: "2rem" }} htmlFor={`${type}_${field}`}>{label}</label>
          <div
            id={`${type}_${field}_help`}
            style={{ fontSize: "1rem", fontWeight: "500", lineHeight: "1.75rem", marginBottom: "1rem"}}
          >
            {helperText}
          </div>
        </>
      )}
      <input
        className={`form-control ${error ? 'is-invalid' : ''}`}
        name={field.includes('_') ? `${type}[${field.replace('_', '][')}]` : `${type}[${field}]`}
        id={`${type}_${field}_id`}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
      {error && (
        <div className="invalid-feedback d-block"  style={{ fontSize: "1rem", fontWeight: "500", lineHeight: "1.75rem"}}>
          {error}
        </div>
      )}
    </div>
  </div>
);

export default TextInput;
